import { Fragment, useEffect, useState } from "react"
import { Badge, Button, Card, Col, Form, Modal, Nav, Row, Spinner, Table } from "react-bootstrap"
import { deleteData, getAllData, insertInto, updateTableNew } from "../../services/Servicos"
import { getErrorMessage, telefoneMask } from "../../services/helpers"
import Loading from "../loading/Loading"
import ModalErrorPretty from "../modal/ModalErrorPretty"

export default function AutomacaoRelatorios() {
    const [abaAtiva, setAbaAtiva] = useState("contatos")

    return (
        <Fragment>
            <Card className='card-user'>
                <Nav variant='pills' activeKey={abaAtiva} onSelect={setAbaAtiva} className="mb-3 mt-2 ms-2">
                    <Nav.Item>
                        <Nav.Link eventKey="contatos"><i className="bi bi-people"></i> Contatos</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="enviar"><i className="bi bi-send"></i> Enviar Relatório</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="historico"><i className="bi bi-clock-history"></i> Histórico</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="reenviar"><i className="bi bi-arrow-repeat"></i> Reenviar PDF</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="configuracao"><i className="bi bi-gear"></i> Configuração</Nav.Link>
                    </Nav.Item>
                </Nav>

                {abaAtiva === "contatos" && <AbaContatos />}
                {abaAtiva === "enviar" && <AbaEnviarRelatorio />}
                {abaAtiva === "reenviar" && <AbaReenviarPDF />}
                {abaAtiva === "historico" && <AbaHistorico />}
                {abaAtiva === "configuracao" && <AbaConfiguracao />}
            </Card>
        </Fragment>
    )
}

/* ===================== ABA CONTATOS ===================== */
function AbaContatos() {
    const [tipos, setTipos] = useState([])
    const [tipoSelecionado, setTipoSelecionado] = useState("")
    const [contatos, setContatos] = useState([])
    const [loading, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [error, setError] = useState({ show: false })

    const carregarTipos = async () => {
        try {
            const resp = await getAllData("automacao-relatorios/tipos")
            setTipos(resp.data)
            if (resp.data.length > 0) {
                setTipoSelecionado(resp.data[0].tipo)
            }
        } catch (err) {
            setError({ show: true, message: getErrorMessage(err) })
        }
    }

    const carregarContatos = async (tipo) => {
        if (!tipo) return
        setLoading(true)
        try {
            const resp = await getAllData(`automacao-relatorios/contatos/${tipo}`)
            setContatos(resp.data.contatos || [])
        } catch (err) {
            setError({ show: true, message: getErrorMessage(err) })
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        carregarTipos()
    }, [])

    useEffect(() => {
        if (tipoSelecionado) carregarContatos(tipoSelecionado)
    }, [tipoSelecionado])

    const toggleAtivo = async (contato) => {
        try {
            await updateTableNew(`automacao-relatorios/contatos/${tipoSelecionado}/${contato.telefone}`, {
                ativo: !contato.ativo
            })
            carregarContatos(tipoSelecionado)
        } catch (err) {
            setError({ show: true, message: getErrorMessage(err) })
        }
    }

    const removerContato = async (telefone) => {
        if (!window.confirm("Deseja realmente remover este contato?")) return
        try {
            await deleteData(`automacao-relatorios/contatos/${tipoSelecionado}/${telefone}`)
            carregarContatos(tipoSelecionado)
        } catch (err) {
            setError({ show: true, message: getErrorMessage(err) })
        }
    }

    return (
        <Fragment>
            <div className="section-filters-table">
                <div className="card-header pb-2">
                    <Row className='justify-content-between align-items-center'>
                        <Col sm='12' md='6' lg='4'>
                            <h3>Contatos por Relatório</h3>
                        </Col>
                        <Col sm='12' md='4' lg='3'>
                            <Form.Select
                                value={tipoSelecionado}
                                onChange={(e) => setTipoSelecionado(e.target.value)}
                            >
                                {tipos.map((t, i) => (
                                    <option key={i} value={t.tipo}>{t.label}</option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col sm='12' md='2' lg='2'>
                            <Button variant="dark" onClick={() => setShowModal(true)}>
                                <i className="bi bi-plus-lg"></i> Novo Contato
                            </Button>
                        </Col>
                    </Row>
                </div>

                <div className="responsive-table mt-3" style={{ minHeight: 300 }}>
                    <Table hover size='sm'>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Nome</th>
                                <th>Telefone</th>
                                <th>Status</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan={5} className="text-center"><Spinner animation="border" size="sm" /> Carregando...</td></tr>
                            ) : contatos.length === 0 ? (
                                <tr><td colSpan={5} className="text-center">Nenhum contato encontrado</td></tr>
                            ) : (
                                contatos.map((c, i) => (
                                    <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td>{c.nome}</td>
                                        <td>{telefoneMask(c.telefone)}</td>
                                        <td>
                                            <Badge
                                                bg={c.ativo ? "success" : "secondary"}
                                                style={{ cursor: "pointer" }}
                                                onClick={() => toggleAtivo(c)}
                                            >
                                                {c.ativo ? "Ativo" : "Inativo"}
                                            </Badge>
                                        </td>
                                        <td>
                                            <Button variant="outline-danger" size="sm" onClick={() => removerContato(c.telefone)}>
                                                <i className="bi bi-trash"></i>
                                            </Button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </div>
            </div>

            {showModal && (
                <ModalNovoContato
                    show={showModal}
                    setShow={setShowModal}
                    tipo={tipoSelecionado}
                    onSalvar={() => carregarContatos(tipoSelecionado)}
                />
            )}
            {error.show && <ModalErrorPretty setShow={setError} {...error} />}
        </Fragment>
    )
}

function ModalNovoContato({ show, setShow, tipo, onSalvar }) {
    const [nome, setNome] = useState("")
    const [telefone, setTelefone] = useState("")
    const [loading, setLoading] = useState({ isLoading: false, msg: "Salvar", style: "primary" })
    const [error, setError] = useState({ show: false })

    const handleClose = () => setShow(false)

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!nome.trim()) {
            setError({ show: true, message: "Nome não informado" })
            return
        }
        if (!telefone.trim() || telefone.replace(/\D/g, '').length < 10) {
            setError({ show: true, message: "Telefone inválido" })
            return
        }

        setLoading({ isLoading: true, msg: "Salvando", style: "warning" })

        try {
            await insertInto(`automacao-relatorios/contatos/${tipo}`, {
                nome: nome.trim(),
                telefone: telefone.replace(/\D/g, '')
            })
            setLoading({ isLoading: false, msg: "Salvo", style: "success" })
            setTimeout(() => {
                onSalvar()
                handleClose()
            }, 800)
        } catch (err) {
            setError({ show: true, message: getErrorMessage(err) })
            setLoading({ isLoading: false, msg: "Salvar", style: "primary" })
        }
    }

    return (
        <Modal show={show} onHide={handleClose} backdrop="static" centered size="md">
            <Modal.Header closeButton>
                <Modal.Title>Novo Contato</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Row className="mb-2">
                        <Col sm="3"><b><Form.Label>Nome:</Form.Label></b></Col>
                        <Col>
                            <Form.Control
                                type="text"
                                value={nome}
                                onChange={(e) => setNome(e.target.value.toUpperCase())}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-2">
                        <Col sm="3"><b><Form.Label>Telefone:</Form.Label></b></Col>
                        <Col>
                            <Form.Control
                                type="text"
                                value={telefone}
                                onChange={(e) => setTelefone(telefoneMask(e.target.value))}
                                placeholder="(00) 00000-0000"
                            />
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant={loading.style} onClick={handleSubmit} disabled={loading.style !== "primary"}>
                    {loading.isLoading ? <Loading msg={loading.msg} /> : loading.msg}
                    {loading.style === "success" && <i className="bi bi-check"></i>}
                </Button>
                <Button variant="secondary" onClick={handleClose}>Cancelar</Button>
            </Modal.Footer>
            {error.show && <ModalErrorPretty setShow={setError} {...error} />}
        </Modal>
    )
}

/* ===================== ABA ENVIAR RELATÓRIO ===================== */
function AbaEnviarRelatorio() {
    const [tipos, setTipos] = useState([])
    const [tipoSelecionado, setTipoSelecionado] = useState("")
    const [loading, setLoading] = useState(false)
    const [resultado, setResultado] = useState(null)
    const [error, setError] = useState({ show: false })

    // envio para número específico
    const [envioEspecifico, setEnvioEspecifico] = useState(false)
    const [nomeEsp, setNomeEsp] = useState("")
    const [telefoneEsp, setTelefoneEsp] = useState("")

    useEffect(() => {
        getAllData("automacao-relatorios/tipos")
            .then(resp => {
                setTipos(resp.data)
                if (resp.data.length > 0) setTipoSelecionado(resp.data[0].tipo)
            })
            .catch(err => setError({ show: true, message: getErrorMessage(err) }))
    }, [])

    const enviarRelatorio = async () => {
        if (!tipoSelecionado) return
        setLoading(true)
        setResultado(null)

        try {
            let resp
            if (envioEspecifico) {
                if (!nomeEsp.trim() || !telefoneEsp.trim()) {
                    setError({ show: true, message: "Informe nome e telefone para envio específico" })
                    setLoading(false)
                    return
                }
                resp = await insertInto(`automacao-relatorios/enviar/${tipoSelecionado}/numero`, {
                    nome: nomeEsp.trim(),
                    telefone: telefoneEsp.replace(/\D/g, '')
                })
            } else {
                resp = await insertInto(`automacao-relatorios/enviar/${tipoSelecionado}`, {})
            }
            setResultado(resp.data)
        } catch (err) {
            setError({ show: true, message: getErrorMessage(err) })
        } finally {
            setLoading(false)
        }
    }

    return (
        <Fragment>
            <div className="section-filters-table">
                <div className="card-header pb-2">
                    <h3>Enviar Relatório</h3>
                </div>

                <Row className="mt-3 mb-3 ms-1">
                    <Col sm="12" md="4">
                        <Form.Label><b>Tipo de Relatório:</b></Form.Label>
                        <Form.Select value={tipoSelecionado} onChange={e => setTipoSelecionado(e.target.value)}>
                            {tipos.map((t, i) => (
                                <option key={i} value={t.tipo}>{t.label}</option>
                            ))}
                        </Form.Select>
                    </Col>
                    <Col sm="12" md="3" className="d-flex align-items-end">
                        <Form.Check
                            type="switch"
                            label="Envio para número específico"
                            checked={envioEspecifico}
                            onChange={() => setEnvioEspecifico(!envioEspecifico)}
                        />
                    </Col>
                </Row>

                {envioEspecifico && (
                    <Row className="mb-3 ms-1">
                        <Col sm="12" md="4">
                            <Form.Label><b>Nome:</b></Form.Label>
                            <Form.Control
                                type="text"
                                value={nomeEsp}
                                onChange={(e) => setNomeEsp(e.target.value.toUpperCase())}
                            />
                        </Col>
                        <Col sm="12" md="4">
                            <Form.Label><b>Telefone:</b></Form.Label>
                            <Form.Control
                                type="text"
                                value={telefoneEsp}
                                onChange={(e) => setTelefoneEsp(telefoneMask(e.target.value))}
                                placeholder="(00) 00000-0000"
                            />
                        </Col>
                    </Row>
                )}

                <Row className="mb-3 ms-1">
                    <Col sm="12" md="3">
                        <Button variant="primary" onClick={enviarRelatorio} disabled={loading}>
                            {loading ? <><Spinner animation="border" size="sm" /> Enviando...</> : <><i className="bi bi-send"></i> Enviar</>}
                        </Button>
                    </Col>
                </Row>

                {resultado && (
                    <div className="mt-3 ms-2 me-2">
                        <Card>
                            <Card.Header><b>Resultado do Envio</b></Card.Header>
                            <Card.Body>
                                <p><b>Mensagem:</b> {resultado.message}</p>
                                {resultado.arquivo && <p><b>Arquivo:</b> {resultado.arquivo}</p>}
                                {resultado.periodo && (
                                    <p><b>Período:</b> {resultado.periodo.inicial} - {resultado.periodo.final}</p>
                                )}
                                {resultado.total_pedidos_atrasados !== undefined && (
                                    <p><b>Pedidos Atrasados:</b> {resultado.total_pedidos_atrasados}</p>
                                )}
                                {resultado.resultados && (
                                    <Table hover size="sm" className="mt-2">
                                        <thead>
                                            <tr>
                                                <th>Nome</th>
                                                <th>Telefone</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {resultado.resultados.map((r, i) => (
                                                <tr key={i}>
                                                    <td>{r.nome}</td>
                                                    <td>{telefoneMask(r.telefone)}</td>
                                                    <td>
                                                        <Badge bg={r.status === "enviado" ? "success" : "danger"}>
                                                            {r.status}
                                                        </Badge>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                )}
                            </Card.Body>
                        </Card>
                    </div>
                )}
            </div>
            {error.show && <ModalErrorPretty setShow={setError} {...error} />}
        </Fragment>
    )
}

/* ===================== ABA HISTÓRICO ===================== */
function AbaHistorico() {
    const [registros, setRegistros] = useState([])
    const [loading, setLoading] = useState(false)
    const [resumo, setResumo] = useState(null)
    const [error, setError] = useState({ show: false })
    const [paginaAtual, setPaginaAtual] = useState(1)
    const [totalPaginas, setTotalPaginas] = useState(1)

    const [filtros, setFiltros] = useState({
        tipo: "",
        status: "",
        data_inicio: "",
        data_fim: "",
        limite: 50
    })

    const carregarHistorico = async (pagina = 1) => {
        setLoading(true)
        try {
            const params = { ...filtros, pagina }
            Object.keys(params).forEach(k => { if (!params[k]) delete params[k] })

            const resp = await getAllData("automacao-relatorios/historico", params)
            setRegistros(resp.data.registros || [])
            setTotalPaginas(resp.data.total_paginas || 1)
            setPaginaAtual(resp.data.pagina || 1)
        } catch (err) {
            setError({ show: true, message: getErrorMessage(err) })
        } finally {
            setLoading(false)
        }
    }

    const carregarResumo = async () => {
        try {
            const resp = await getAllData("automacao-relatorios/historico/resumo")
            setResumo(resp.data)
        } catch (err) {
            console.error(err)
        }
    }

    useEffect(() => {
        carregarHistorico()
        carregarResumo()
    }, [])

    const handleFiltrar = (e) => {
        e.preventDefault()
        carregarHistorico(1)
    }

    return (
        <Fragment>
            <div className="section-filters-table">
                <div className="card-header pb-2">
                    <h3>Histórico de Envios</h3>
                </div>

                {resumo && (
                    <Row className="mt-2 mb-3 ms-1 me-1">
                        <Col sm="6" md="3">
                            <Card className="text-center p-2">
                                <small className="text-muted">Enviados</small>
                                <h4 className="text-success">{resumo.total_enviados}</h4>
                            </Card>
                        </Col>
                        <Col sm="6" md="3">
                            <Card className="text-center p-2">
                                <small className="text-muted">Erros</small>
                                <h4 className="text-danger">{resumo.total_erros}</h4>
                            </Card>
                        </Col>
                        <Col sm="6" md="3">
                            <Card className="text-center p-2">
                                <small className="text-muted">Forçados</small>
                                <h4 className="text-warning">{resumo.total_forcados}</h4>
                            </Card>
                        </Col>
                        <Col sm="6" md="3">
                            <Card className="text-center p-2">
                                <small className="text-muted">Último Envio (Cargas)</small>
                                <small>{resumo.ultimo_envio_cargas ? new Date(resumo.ultimo_envio_cargas).toLocaleString() : "-"}</small>
                            </Card>
                        </Col>
                    </Row>
                )}

                <Form onSubmit={handleFiltrar}>
                    <Row className="mb-3 ms-1 me-1 align-items-end">
                        <Col sm="6" md="2">
                            <Form.Label><b>Tipo:</b></Form.Label>
                            <Form.Select value={filtros.tipo} onChange={e => setFiltros(l => ({ ...l, tipo: e.target.value }))}>
                                <option value="">Todos</option>
                                <option value="cargas">Cargas</option>
                                <option value="telhas_isotermicas">Telhas Isotérmicas</option>
                            </Form.Select>
                        </Col>
                        <Col sm="6" md="2">
                            <Form.Label><b>Status:</b></Form.Label>
                            <Form.Select value={filtros.status} onChange={e => setFiltros(l => ({ ...l, status: e.target.value }))}>
                                <option value="">Todos</option>
                                <option value="enviado">Enviado</option>
                                <option value="erro">Erro</option>
                                <option value="pendente">Pendente</option>
                            </Form.Select>
                        </Col>
                        <Col sm="6" md="2">
                            <Form.Label><b>Data Início:</b></Form.Label>
                            <Form.Control type="date" value={filtros.data_inicio} onChange={e => setFiltros(l => ({ ...l, data_inicio: e.target.value }))} />
                        </Col>
                        <Col sm="6" md="2">
                            <Form.Label><b>Data Fim:</b></Form.Label>
                            <Form.Control type="date" value={filtros.data_fim} onChange={e => setFiltros(l => ({ ...l, data_fim: e.target.value }))} />
                        </Col>
                        <Col sm="12" md="2">
                            <Button type="submit" variant="dark">
                                <i className="bi bi-search"></i> Filtrar
                            </Button>
                        </Col>
                    </Row>
                </Form>

                <div style={{ overflowX: "auto", minHeight: 400 }}>
                    <Table hover size='sm' style={{ whiteSpace: "nowrap" }}>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Tipo</th>
                                <th>Destinatário</th>
                                <th>Telefone</th>
                                <th>Arquivo</th>
                                <th>Status Envio</th>
                                <th>Erro</th>
                                <th>Forçado</th>
                                <th>Período Inicial</th>
                                <th>Período Final</th>
                                <th>ID Msg WPP</th>
                                <th>Enviado</th>
                                <th>Data Envio</th>
                                <th>Entregue</th>
                                <th>Data Entrega</th>
                                <th>Lido</th>
                                <th>Data Leitura</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan={19} className="text-center"><Spinner animation="border" size="sm" /> Carregando...</td></tr>
                            ) : registros.length === 0 ? (
                                <tr><td colSpan={19} className="text-center">Nenhum registro encontrado</td></tr>
                            ) : (
                                registros.map((r, i) => (
                                    <tr key={r.id || i}>
                                        <td>{r.id}</td>
                                        <td>{r.tipo_relatorio}</td>
                                        <td>{r.nome_destinatario}</td>
                                        <td>{telefoneMask(r.telefone_destinatario)}</td>
                                        <td><small>{r.nome_arquivo}</small></td>
                                        <td>
                                            <Badge bg={r.status_envio === "enviado" ? "success" : r.status_envio === "erro" ? "danger" : "warning"}>
                                                {r.status_envio}
                                            </Badge>
                                        </td>
                                        <td><small className="text-danger">{r.erro_mensagem || "-"}</small></td>
                                        <td>{r.envio_forcado ? "Sim" : "Não"}</td>
                                        <td><small>{r.periodo_inicial || "-"}</small></td>
                                        <td><small>{r.periodo_final || "-"}</small></td>
                                        <td><small>{r.id_wpp_message || "-"}</small></td>
                                        <td>
                                            <Badge bg={r.enviado ? "success" : "secondary"}>
                                                {r.enviado ? "Sim" : "Não"}
                                            </Badge>
                                        </td>
                                        <td><small>{r.data_envio ? new Date(r.data_envio).toLocaleString() : "-"}</small></td>
                                        <td>
                                            <Badge bg={r.entregue ? "success" : "secondary"}>
                                                {r.entregue ? "Sim" : "Não"}
                                            </Badge>
                                        </td>
                                        <td><small>{r.data_entrega ? new Date(r.data_entrega).toLocaleString() : "-"}</small></td>
                                        <td>
                                            <Badge bg={r.lido ? "info" : "secondary"}>
                                                {r.lido ? "Sim" : "Não"}
                                            </Badge>
                                        </td>
                                        <td><small>{r.data_leitura ? new Date(r.data_leitura).toLocaleString() : "-"}</small></td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </div>

                {totalPaginas > 1 && (
                    <Row className="mt-2 mb-2 justify-content-center">
                        <Col xs="auto">
                            <Button variant="outline-dark" size="sm" disabled={paginaAtual <= 1} onClick={() => carregarHistorico(paginaAtual - 1)}>
                                <i className="bi bi-chevron-left"></i> Anterior
                            </Button>
                        </Col>
                        <Col xs="auto" className="d-flex align-items-center">
                            Página {paginaAtual} de {totalPaginas}
                        </Col>
                        <Col xs="auto">
                            <Button variant="outline-dark" size="sm" disabled={paginaAtual >= totalPaginas} onClick={() => carregarHistorico(paginaAtual + 1)}>
                                Próxima <i className="bi bi-chevron-right"></i>
                            </Button>
                        </Col>
                    </Row>
                )}
            </div>
            {error.show && <ModalErrorPretty setShow={setError} {...error} />}
        </Fragment>
    )
}

/* ===================== ABA REENVIAR PDF ===================== */
function AbaReenviarPDF() {
    const [relatorios, setRelatorios] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState({ show: false })
    const [modalReenvio, setModalReenvio] = useState({ show: false, relatorio: null })

    const carregarRelatorios = async () => {
        setLoading(true)
        try {
            const resp = await getAllData("automacao-relatorios/relatorios")
            setRelatorios(resp.data.relatorios || [])
        } catch (err) {
            setError({ show: true, message: getErrorMessage(err) })
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        carregarRelatorios()
    }, [])

    return (
        <Fragment>
            <div className="section-filters-table">
                <div className="card-header pb-2">
                    <Row className="justify-content-between align-items-center">
                        <Col sm="12" md="6">
                            <h3>Relatórios Gerados (PDFs)</h3>
                        </Col>
                        <Col sm="12" md="2">
                            <Button variant="outline-dark" size="sm" onClick={carregarRelatorios} disabled={loading}>
                                <i className="bi bi-arrow-clockwise"></i> Atualizar
                            </Button>
                        </Col>
                    </Row>
                </div>

                <div className="responsive-table mt-3" style={{ minHeight: 300 }}>
                    <Table hover size='sm'>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Nome do Arquivo</th>
                                <th>Tipo</th>
                                <th>Tamanho</th>
                                <th>Criado em</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan={6} className="text-center"><Spinner animation="border" size="sm" /> Carregando...</td></tr>
                            ) : relatorios.length === 0 ? (
                                <tr><td colSpan={6} className="text-center">Nenhum relatório encontrado</td></tr>
                            ) : (
                                relatorios.map((r, i) => (
                                    <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td><small>{r.nome}</small></td>
                                        <td>
                                            <Badge bg={r.tipo === "cargas" ? "primary" : "info"}>
                                                {r.tipo === "cargas" ? "Cargas" : r.tipo === "telhas_isotermicas" ? "Telhas Isotérmicas" : r.tipo}
                                            </Badge>
                                        </td>
                                        <td>{r.tamanho_kb} KB</td>
                                        <td><small>{r.criado_em ? new Date(r.criado_em).toLocaleString() : "-"}</small></td>
                                        <td>
                                            <Button
                                                variant="outline-primary"
                                                size="sm"
                                                onClick={() => setModalReenvio({ show: true, relatorio: r })}
                                            >
                                                <i className="bi bi-send"></i> Reenviar
                                            </Button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </div>
            </div>

            {modalReenvio.show && (
                <ModalReenviarPDF
                    show={modalReenvio.show}
                    setShow={setModalReenvio}
                    relatorio={modalReenvio.relatorio}
                />
            )}
            {error.show && <ModalErrorPretty setShow={setError} {...error} />}
        </Fragment>
    )
}

function ModalReenviarPDF({ show, setShow, relatorio }) {
    const [nome, setNome] = useState("")
    const [telefone, setTelefone] = useState("")
    const [loading, setLoading] = useState({ isLoading: false, msg: "Enviar", style: "primary" })
    const [error, setError] = useState({ show: false })
    const [resultado, setResultado] = useState(null)

    const handleClose = () => setShow({ show: false, relatorio: null })

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!nome.trim()) {
            setError({ show: true, message: "Nome não informado" })
            return
        }
        if (!telefone.trim() || telefone.replace(/\D/g, '').length < 10) {
            setError({ show: true, message: "Telefone inválido" })
            return
        }

        setLoading({ isLoading: true, msg: "Enviando", style: "warning" })

        try {
            const resp = await insertInto("automacao-relatorios/reenviar", {
                nome_arquivo: relatorio.nome,
                telefone: telefone.replace(/\D/g, ''),
                nome: nome.trim(),
                tipo: relatorio.tipo
            })
            setResultado(resp.data)
            setLoading({ isLoading: false, msg: "Enviado", style: "success" })
        } catch (err) {
            setError({ show: true, message: getErrorMessage(err) })
            setLoading({ isLoading: false, msg: "Enviar", style: "primary" })
        }
    }

    return (
        <Modal show={show} onHide={handleClose} backdrop="static" centered size="md">
            <Modal.Header closeButton>
                <Modal.Title>Reenviar Relatório</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="mb-3">
                    <Col>
                        <Card className="bg-light">
                            <Card.Body className="p-2">
                                <small><b>Arquivo:</b> {relatorio.nome}</small><br />
                                <small><b>Tipo:</b> {relatorio.tipo === "cargas" ? "Cargas" : "Telhas Isotérmicas"}</small><br />
                                <small><b>Criado em:</b> {relatorio.criado_em ? new Date(relatorio.criado_em).toLocaleString() : "-"}</small>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Form onSubmit={handleSubmit}>
                    <Row className="mb-2">
                        <Col sm="3"><b><Form.Label>Nome:</Form.Label></b></Col>
                        <Col>
                            <Form.Control
                                type="text"
                                value={nome}
                                onChange={(e) => setNome(e.target.value.toUpperCase())}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-2">
                        <Col sm="3"><b><Form.Label>Telefone:</Form.Label></b></Col>
                        <Col>
                            <Form.Control
                                type="text"
                                value={telefone}
                                onChange={(e) => setTelefone(telefoneMask(e.target.value))}
                                placeholder="(00) 00000-0000"
                            />
                        </Col>
                    </Row>
                </Form>

                {resultado && (
                    <Card className="mt-3 border-success">
                        <Card.Body className="p-2">
                            <small className="text-success"><i className="bi bi-check-circle"></i> {resultado.message}</small><br />
                            {resultado.destinatario && (
                                <small><b>Enviado para:</b> {resultado.destinatario.nome} - {telefoneMask(resultado.destinatario.telefone)}</small>
                            )}
                        </Card.Body>
                    </Card>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant={loading.style} onClick={handleSubmit} disabled={loading.style !== "primary"}>
                    {loading.isLoading ? <Loading msg={loading.msg} /> : loading.msg}
                    {loading.style === "success" && <i className="bi bi-check"></i>}
                </Button>
                <Button variant="secondary" onClick={handleClose}>Fechar</Button>
            </Modal.Footer>
            {error.show && <ModalErrorPretty setShow={setError} {...error} />}
        </Modal>
    )
}

/* ===================== ABA CONFIGURAÇÃO ===================== */

const DIAS_SEMANA = [
    { value: 0, label: "Domingo" },
    { value: 1, label: "Segunda" },
    { value: 2, label: "Terça" },
    { value: 3, label: "Quarta" },
    { value: 4, label: "Quinta" },
    { value: 5, label: "Sexta" },
    { value: 6, label: "Sábado" },
]

function AbaConfiguracao() {
    const [config, setConfig] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState({ show: false })

    const carregarConfig = () => {
        setLoading(true)
        getAllData("automacao-relatorios/configuracao")
            .then(resp => setConfig(resp.data))
            .catch(err => setError({ show: true, message: getErrorMessage(err) }))
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        carregarConfig()
    }, [])

    if (loading) return <div className="text-center p-4"><Spinner animation="border" /> Carregando configuração...</div>

    if (!config) return <div className="text-center p-4">Erro ao carregar configuração</div>

    return (
        <Fragment>
            <div className="section-filters-table">
                <div className="card-header pb-2">
                    <h3>Configuração das Automações</h3>
                </div>

                <Row className="mt-3 ms-1 me-1">
                    {config.automacoes && config.automacoes.map((a, i) => (
                        <Col sm="12" md="6" key={i} className="mb-3">
                            <CardConfiguracaoAutomacao
                                automacao={a}
                                onAtualizar={carregarConfig}
                                setError={setError}
                            />
                        </Col>
                    ))}
                </Row>

                {config.limpeza_pdfs && (
                    <Row className="mt-2 ms-1 me-1 mb-3">
                        <Col sm="12" md="6">
                            <Card>
                                <Card.Header><b>Limpeza de PDFs</b></Card.Header>
                                <Card.Body>
                                    <p><b>Horário:</b> {config.limpeza_pdfs.horario}</p>
                                    <p><b>Dias:</b> {config.limpeza_pdfs.dias}</p>
                                    <p><b>Retenção:</b> {config.limpeza_pdfs.retencao}</p>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                )}
            </div>
            {error.show && <ModalErrorPretty setShow={setError} {...error} />}
        </Fragment>
    )
}

function CardConfiguracaoAutomacao({ automacao, onAtualizar, setError }) {
    const agendamento = automacao.agendamento || {}
    const [editando, setEditando] = useState(false)
    const [horario, setHorario] = useState(agendamento.horario || "")
    const [diasSelecionados, setDiasSelecionados] = useState(agendamento.dias_semana || [])
    const [saving, setSaving] = useState({ isLoading: false, msg: "Salvar", style: "primary" })

    const toggleDia = (dia) => {
        setDiasSelecionados(last => {
            if (last.includes(dia)) return last.filter(d => d !== dia)
            return [...last, dia]
        })
    }

    const handleSalvar = async () => {
        if (!horario) {
            setError({ show: true, message: "Horário não informado" })
            return
        }
        if (diasSelecionados.length === 0) {
            setError({ show: true, message: "Selecione pelo menos um dia da semana" })
            return
        }

        setSaving({ isLoading: true, msg: "Salvando", style: "warning" })

        try {
            await updateTableNew(`automacao-relatorios/agendamento/${automacao.tipo}`, {
                horario,
                dias: diasSelecionados
            })
            setSaving({ isLoading: false, msg: "Salvo", style: "success" })
            setTimeout(() => {
                setEditando(false)
                setSaving({ isLoading: false, msg: "Salvar", style: "primary" })
                onAtualizar()
            }, 1000)
        } catch (err) {
            setError({ show: true, message: getErrorMessage(err) })
            setSaving({ isLoading: false, msg: "Salvar", style: "primary" })
        }
    }

    const handleCancelar = () => {
        setHorario(agendamento.horario || "")
        setDiasSelecionados(agendamento.dias_semana || [])
        setEditando(false)
    }

    return (
        <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
                <b>{automacao.label}</b>
                {!editando && (
                    <Button variant="outline-dark" size="sm" onClick={() => setEditando(true)}>
                        <i className="bi bi-pencil"></i> Editar
                    </Button>
                )}
            </Card.Header>
            <Card.Body>
                {editando ? (
                    <Fragment>
                        <Row className="mb-3">
                            <Col sm="4"><b>Horário:</b></Col>
                            <Col sm="8">
                                <Form.Control
                                    type="time"
                                    value={horario}
                                    onChange={(e) => setHorario(e.target.value)}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col sm="4"><b>Dias:</b></Col>
                            <Col sm="8">
                                {DIAS_SEMANA.map((d) => (
                                    <Form.Check
                                        key={d.value}
                                        inline
                                        type="checkbox"
                                        label={d.label}
                                        checked={diasSelecionados.includes(d.value)}
                                        onChange={() => toggleDia(d.value)}
                                    />
                                ))}
                            </Col>
                        </Row>
                        <Row>
                            <Col className="d-flex gap-2">
                                <Button variant={saving.style} size="sm" onClick={handleSalvar} disabled={saving.style !== "primary"}>
                                    {saving.isLoading ? <Loading msg={saving.msg} /> : saving.msg}
                                    {saving.style === "success" && <i className="bi bi-check"></i>}
                                </Button>
                                <Button variant="outline-secondary" size="sm" onClick={handleCancelar}>
                                    Cancelar
                                </Button>
                            </Col>
                        </Row>
                    </Fragment>
                ) : (
                    <Fragment>
                        <p><b>Horário:</b> {agendamento.horario || "-"}</p>
                        <p><b>Dias:</b> {agendamento.dias_semana_label || "-"}</p>
                        <p><b>Ativo:</b> <Badge bg={agendamento.ativo ? "success" : "secondary"}>{agendamento.ativo ? "Sim" : "Não"}</Badge></p>
                        <p><b>Contatos Ativos:</b> {automacao.contatos_ativos} / {automacao.total_contatos}</p>
                    </Fragment>
                )}
            </Card.Body>
        </Card>
    )
}


